import { render, staticRenderFns } from "./TwCompanyIdAndNameSuggestMultipleSelect.vue?vue&type=template&id=96408912&scoped=true&"
import script from "./TwCompanyIdAndNameSuggestMultipleSelect.vue?vue&type=script&lang=js&"
export * from "./TwCompanyIdAndNameSuggestMultipleSelect.vue?vue&type=script&lang=js&"
import style0 from "./TwCompanyIdAndNameSuggestMultipleSelect.vue?vue&type=style&index=0&id=96408912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96408912",
  null
  
)

export default component.exports